import React from 'react';
import { connect } from 'react-redux';
import {
  Redirect,
} from 'react-router-dom'

import {
  logout as initiateLogout,
  isLoggedIn,
} from 'ducks/authentication';


class Logout extends React.Component {
  componentDidMount() {
    this.props.onMount();
  }
  render() {
    const {
      isLoggedIn,
    } = this.props;
    //
    console.log('check logged in', isLoggedIn)

    if (!isLoggedIn) {
      return <Redirect to={{
          pathname: '/',
          state: { from: this.props.location }
        }}/>
      }
      return (
        <div className='Logout'>
          <h1>Déconnexion en cours...</h1>
      </div>
    );

  }
}

const mapStateToProps = ($$state) => {
  return {
    isLoggedIn: isLoggedIn($$state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onMount: () => {dispatch(initiateLogout());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/components/Logout.jsx